import { set } from 'lodash';
import { MutationTree } from 'vuex';

export const state = () => ({
  id: null,
  query: {
    where: {},
    sort: {
      createdAt: 'DESC'
    },
    offset: 0,
    limit: 10
  },
  table: {
    footer: {
      'items-per-page-options': [10, 25, 50, 100],
      'show-current-page': true,
      'show-first-last-page': true,
      'page-text': '{{pageStart}}',
      options: {
        page: 1,
        itemsPerPage: 10,
        sortBy: ['createdAt'],
        sortDesc: [true],
        groupBy: [],
        groupDesc: [],
        multiSort: false,
        mustSort: true
      }
    },
    filter: {
      trait: '',
      category: [], // product category id
      dnaCategoryId: [], // genebox panel id
      type: [],
      status: [],
      price: {
        from: 0,
        to: 0
      },
      endDate: {
        from: null,
        to: null
      },
      createdAt: {
        from: null,
        to: null
      }
    },
    options: {
      page: 1,
      itemsPerPage: 10,
      sortBy: ['createdAt'],
      sortDesc: [true],
      groupBy: [],
      groupDesc: [],
      multiSort: false,
      mustSort: true
    }
  }
});

export type ProductReport = ReturnType<typeof state>;

export const mutations: MutationTree<ProductReport> = {
  changeId: (state, id) => (state.id = id),
  changeQuery: (state, query) => Object.assign(state.query, query),
  changeTableFilter: (state, filter) => {
    Object.assign(state.table, { filter });
    Object.assign(state.query.where, {
      trait: filter.trait,
      category: filter.category,
      type: filter.type,
      status: filter.status,
      price: {
        from: filter.price.from,
        to: filter.price.to
      },
      endDate: {
        from: filter.endDate.from,
        to: filter.endDate.to
      },
      createdAt: {
        from: filter.createdAt.from,
        to: filter.createdAt.to
      }
    });
  },
  changeTableOptions: (state, options) => {
    Object.assign(state.table, { options });
    Object.assign(state.table.footer, { options });
    Object.assign(state.query, {
      sort: set({}, options.sortBy[0], options.sortDesc[0] ? 'DESC' : 'ASC'),
      limit: options.itemsPerPage,
      offset: (options.page - 1) * options.itemsPerPage
    });
  }
};
